import { ERROR, LOADING, SUCCESS } from '../enums/states';
import updateObjectByPath from './updateObjectByPath';

const createFetchingHandlers = (actions, mapKey) => {
  const [LOADING_ACTION, SUCCESS_ACTION, ERROR_ACTION] = actions;
  const output = {};
  if (LOADING_ACTION) {
    output[LOADING_ACTION] = (state, action) => {
      const newState = updateObjectByPath(state, mapKey(state, action), {
        status: LOADING,
      });
      return newState;
    };
  }

  if (SUCCESS_ACTION) {
    output[SUCCESS_ACTION] = (state, action) => {
      const newState = updateObjectByPath(state, mapKey(state, action), {
        status: SUCCESS,
      });
      return newState;
    };
  }

  if (ERROR_ACTION) {
    output[ERROR_ACTION] = (state, action) => {
      const newState = updateObjectByPath(state, mapKey(state, action), {
        status: ERROR,
        error: action.payload,
      });
      return newState;
    };
  }

  return output;
};

export default createFetchingHandlers;
